<a routerLink="{{link}}" routerLinkActive="border-b-2" class="flex w-full h-full justify-center gap-4 items-center border-solid hover:border-b-2   border-black" [routerLinkActiveOptions]="{ exact: true }" [ngClass]="width" [attr.aria-label]="title" tabindex="0">
  @if(icon) {
    <dsr-icon name="{{icon}}" size="3rem" color="{{color}}" aria-hidden="true" />
  }
  <span class="!font-renault-group-semi-bold dsr-typescale-body-small"> {{title}}</span>
</a>